import { App, Button } from 'antd'

/** Optional extras for a toast: a click action that turns it into a link. */
export interface NotificationOptions {
    /** Invoked when the toast (or its action button) is clicked. */
    onClick?: () => void
    /** Label for the action button shown when `onClick` is set. */
    actionLabel?: string
}

export const useNotification = () => {
    const { notification } = App.useApp()

    const showError = (message?: string, description?: string, options?: NotificationOptions) => {
        const key = `err-${Date.now()}`
        notification.error({
            key,
            duration: 10,
            showProgress: true,
            pauseOnHover: true,
            title: message || 'Помилка',
            description: description || 'Сталася помилка. Спробуйте ще раз пізніше.',
            placement: 'topRight',
            ...buildActionProps(options, () => notification.destroy(key)),
        })
    }

    const showSuccess = (message?: string, description?: string, options?: NotificationOptions) => {
        const key = `ok-${Date.now()}`
        notification.success({
            key,
            duration: 5,
            showProgress: true,
            pauseOnHover: true,
            title: message || 'Успіх',
            description: description || 'Операція виконана успішно.',
            placement: 'topRight',
            ...buildActionProps(options, () => notification.destroy(key)),
        })
    }

    return { showError, showSuccess }
}

/**
 * When `options.onClick` is set, makes the whole toast clickable and adds an
 * action button. Closes the toast after the action runs. Returns an empty
 * object otherwise, so existing two-argument calls are unaffected.
 */
function buildActionProps(options: NotificationOptions | undefined, close: () => void) {
    if (!options?.onClick) return {}

    const handle = () => {
        options.onClick?.()
        close()
    }

    return {
        onClick: handle,
        style: { cursor: 'pointer' },
        btn: (
            <Button
                type="primary"
                size="small"
                onClick={(e) => {
                    e.stopPropagation()
                    handle()
                }}
            >
                {options.actionLabel ?? 'Перейти'}
            </Button>
        ),
    }
}
